// extracted by mini-css-extract-plugin
export default {"chiSono":"TitleChiSono_chiSono__VZC77"};